import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Card, CardHeader, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, IconButton, Chip } from '@mui/material';
import axios from 'src/utils/axios';
import moment from 'moment';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Skeleton from '@mui/material/Skeleton';

function ReceiptCustomerDetail() {

    const { CustomerNo } = useParams();
    const navigate = useNavigate();

    const [customerReceiptsData, setCustomerReceiptsData] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    useEffect(() => {
        getCustomerAllReceiptsInformation();
    }, []);

    const getCustomerAllReceiptsInformation = () => {
        axios.get(`GetCustomerAllReceiptsInformation/${CustomerNo}`)
            .then((response) => {
                var customerData = response.data;
                setCustomerReceiptsData(Array.isArray(customerData) ? customerData : []);
                setPage(0);
                setLoading(false);
            }).catch((error) => {
                setLoading(false);
            });
    }

    const handleGoBack = () => {
        navigate(-1);
    };

    const RouteReceiptDetailPage = (ReceiptNumber) => {
        navigate(`/SarisQueries/ReceiptDetails/${ReceiptNumber}`);
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Container maxWidth="lg" sx={{ py: 3 }}>
            <Card>
                <CardHeader
                    avatar={
                        <IconButton onClick={() => { handleGoBack(); }} size="small">
                            <ArrowBackIcon />
                        </IconButton>
                    }
                    title="Müşteri Fiş Bilgileri"
                />
                <Divider />
                <TableContainer>
                    <Table size='small'>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 700 }}>Fiş No</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Servis</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Çağrı Tarihi</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>İşlem Tarihi</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Ürün</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Başvuru Nedeni</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loading ? (
                                Array.from(new Array(3)).map((_, index) => (
                                    <TableRow key={index}>
                                        {Array.from(new Array(6)).map((_, cellIndex) => (
                                            <TableCell key={cellIndex} colSpan={1}>
                                                <Skeleton animation="pulse" variant="text" width={150} />
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))
                            ) : (
                                customerReceiptsData.length > 0 && customerReceiptsData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((customer, index) => (
                                    <TableRow key={index}>
                                        <TableCell>
                                            <Chip
                                                label={customer.FIS_NO}
                                                size="small"
                                                variant="outlined"
                                                clickable
                                                onClick={() => { RouteReceiptDetailPage(customer.FIS_NO); }}
                                            />
                                        </TableCell>
                                        <TableCell>{customer.KUL_BIRIM_KODU}</TableCell>
                                        <TableCell>{moment(customer.CAGRI_TARIHI).format('DD-MM-YYYY HH:mm:ss')}</TableCell>
                                        <TableCell>{moment(customer.ISLEM_TARIHI).format('DD-MM-YYYY HH:mm:ss')}</TableCell>
                                        <TableCell>{customer.ACIKLAMA}</TableCell>
                                        <TableCell>{customer.BASVURU_NEDENI}</TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50]}
                    component="div"
                    count={customerReceiptsData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Card>
        </Container>
    );
}

export default ReceiptCustomerDetail
